// @flow
import {
  CircularProgress,
  Icon,
  Typography,
} from '@material-ui/core';
import React from 'react';
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";

type Props = {
  classes: Object,
  email: string,
  loading: boolean,
  reset: Function,
  t: Function
}

const styles = theme => {
  return {
    container: {
      margin: '0 auto',
      maxWidth: 450,
      paddingTop: 80,
      textAlign: "center",
    },
    fakeLink: {
      color: "blue",
      cursor: "pointer",
      textDecoration: "underline",
    },
    icon: {
      color: theme.palette.ava.blue,
      fontSize: 100,
    }
  }
};

class ScribeLoginEmailVerification extends React.Component<Props> {
  onKeyDown(e) {
    const { reset } = this.props
    if (e.keyCode === 27) {
      reset()
    }
  }

  render() {
    const {
      classes,
      email,
      loading,
      reset,
      t
    } = this.props;
    return (
      <>
        {loading && (
          <div className={classes.container}>
            <CircularProgress color="secondary" style={{ margin: '0 auto' }} />
          </div>
        )}
        {!loading && (
          <div className={classes.container}>
            <Icon color="primary" className={classes.icon}>
              email
            </Icon>
            <Typography variant="h3" align="center" gutterBottom>
              {t("signin-messages.verifyEmailLoading.checkEmail")}
            </Typography>
            <Typography variant="body1">
              {t("signin-messages.verifyEmailLoading.toConfirmEmailClikOnLinkWeSendOn")}{" "}
              {email || "guillaume.soulie1@ava.me"}.
            </Typography>
            <br />
            <Typography variant="body1">
              {t("signin-messages.verifyEmailLoading.youDontGetOurEmail")}{" "}
              {t("signin-messages.verifyEmailLoading.tryInSpam")}{" "}
              <span
                className={classes.fakeLink}
                role="link"
                tabIndex="0"
                onClick={reset}
                onKeyDown={e => this.onKeyDown(e)}>
                {t("signin-messages.verifyEmailLoading.tryAnotherAdress")}
              </span>
              .
            </Typography>
          </div>
        )}
      </>
    );
  }
}
export default withTranslation()(withStyles(styles)(ScribeLoginEmailVerification));
